'use client';
import React, { useEffect } from 'react';

export interface BenzingaQuizProps {
  form_factor?: string;
  partner_id: string;
  quiz_id?: string;
}

export const BenzingaQuiz: React.FC<BenzingaQuizProps> = ({ form_factor = 'desktop', partner_id, quiz_id = '' }) => {
  useEffect(() => {
    const scriptSrc = 'https://client.riverdrop.com/dist/quiz-common/assets/index.js';
    if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
      const script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      script.type = 'module';
      document.head.appendChild(script);
      script.onload = () => {
        window.dispatchEvent(new Event('riverdrop-quiz-init'));
      };
    } else {
      // If script is already loaded, dispatch the event
      window.dispatchEvent(new Event('riverdrop-quiz-init'));
    }
  }, []);

  if (partner_id === '' || quiz_id === '') {
    return null;
  }
  return (
    <div className="block min-h-[650px]">
      {React.createElement('riverdrop-quiz', {
        authtype: 'benzinga_results',
        formfactor: form_factor,
        idlocation: 'benzinga_uid',
        loginidentifier: 'benzinga_uid',
        maxheight: '600',
        maxwidth: '800',
        outerpadding: '25px',
        partnerid: partner_id,
        quizid: quiz_id,
        theme: 'light',
      })}
    </div>
  );
};
